import React, { useEffect, useState } from 'react';

import Typography from '@material-ui/core/Typography';

import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import WarningOutlinedIcon from '@material-ui/icons/WarningOutlined';

import SimpleDialog from '../Dialog/Dialog';
import { SelectOption } from '../Inputs/Select/Select';
import { Text } from '../Inputs/Text/Text';
import { ButtonDefault, ButtonWarning } from '../Button/Button';
import { ToastCF } from '../Toast/Toast';
import { useStyles } from './Style';

import EnumService from '../../services/Enum';

const DialogInvalidarProva = ({ open, idProva, codigo, onClose, onConfirm, loading }) => {
    const classes = useStyles();

    const [motivo, setMotivo] = useState('');
    const [observacao, setObservacao] = useState('');
    const [optionsMotivo, setOptionsMotivo] = useState([]);
    const [loadingMotivos, setLoadingMotivos] = useState(false);
    const [toast, setToast] = useState({ open: false, message: '', type: 'error' });

    useEffect(() => {
        if (open) {
            setMotivo('');
            setObservacao('');
        }
    }, [open]);

    useEffect(() => {
        setLoadingMotivos(true);

        EnumService.listarMotivosInvalidacao()
            .then(res => setOptionsMotivo(res.data))
            .catch(() => setToast({ open: true, message: 'Não foi possível carregar os motivos de invalidação.', type: 'error' }))
            .finally(() => setLoadingMotivos(false));
    }, []);

    const precisaObservacao = motivo === 'OUTRO';
    const observacaoOk = !precisaObservacao || Boolean(observacao.trim());
    const valido = Boolean(motivo) && observacaoOk;

    const handleConfirm = () => {
        if (!valido || !onConfirm) return;

        onConfirm({
            motivo,
            observacao: observacao.trim() ? observacao.trim() : null,
        });
    };

    const actions = (
        <>
            <ButtonWarning
                name="Invalidar prova"
                startIcon={<WarningOutlinedIcon />}
                onClick={handleConfirm}
                disabled={!valido || Boolean(loading)}
                style={{ margin: 4 }}
            />
            <ButtonDefault
                name="Cancelar"
                startIcon={<ClearOutlinedIcon />}
                onClick={onClose}
                disabled={Boolean(loading)}
                style={{ margin: 4 }}
            />
        </>
    );

    return (
        <>
            <ToastCF
                open={toast.open}
                message={toast.message}
                type={toast.type}
                handleClose={() => setToast(anterior => ({ ...anterior, open: false }))}
            />

            <SimpleDialog
                openDialog={Boolean(open)}
                title="Invalidar prova"
                closeDialog={onClose}
                actions={actions}
                fullWidth={true}
                maxWidth="sm"
            >
                <div className={classes.dialogInvalidar}>
                    <Typography variant="body2" color="textSecondary" className={classes.dialogInvalidarProva}>
                        {codigo ? `Prova ${codigo}` : `Prova ${idProva || ''}`}
                    </Typography>

                    <SelectOption
                        label="Motivo"
                        value={motivo}
                        onChange={event => setMotivo(event.target.value)}
                        options={optionsMotivo}
                        blankName="Selecione o motivo"
                        disabled={Boolean(loading) || loadingMotivos}
                    />

                    <Text
                        label={precisaObservacao ? 'Observação (obrigatória)' : 'Observação (opcional)'}
                        value={observacao}
                        onChange={event => setObservacao(event.target.value)}
                        multiline
                        rows={3}
                        variant="outlined"
                        disabled={Boolean(loading)}
                        helperText={precisaObservacao && !observacao.trim() ? 'Descreva o motivo da invalidação.' : ' '}
                    />
                </div>
            </SimpleDialog>
        </>
    );
};

export default DialogInvalidarProva;
